import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";

export const ComputerDetailTable = ({ data }) => {
  const { list, header } = data || {};
  return (
    <div className={styles.infoTable}>
      <div className={styles.header}>
        <div className={styles.numberLabel}>No.</div>
        <div className={styles.infoLabel}>
          <div>{header?.heading}</div>
          <div className={styles.headerIcon}>
            <ConditionalRenderer condition={header?.icon}>
              <header.icon />
            </ConditionalRenderer>
          </div>
        </div>
      </div>
      {list?.map((item, index) => (
        <div className={styles.singleRow} key={item?.id}>
          <div className={styles.rowNumber}>{index + 1}</div>
          <div className={styles.info}>
            <div className={styles.label}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <item.LabelIcon />
              </div>

              {item?.label}
            </div>
            <ConditionalRenderer condition={!item?.isValueTag}>
              <div style={{ color: item?.valueColor }}>
                {/* <ConditionalRenderer
                  condition={!item?.value && item?.valueIcon}
                >
                  <item.valueIcon />
                </ConditionalRenderer> */}
                {item?.value || <span style={{ color: "red" }}>--</span>}
              </div>
            </ConditionalRenderer>
            <ConditionalRenderer condition={item?.isValueTag}>
              <div className={styles.valueTag}>
                {/* <ConditionalRenderer condition={item?.tagIcon}>
                  <item.tagIcon />
                </ConditionalRenderer> */}
                {item?.value}
              </div>
            </ConditionalRenderer>
          </div>
        </div>
      ))}
    </div>
  );
};
